import { useLocation } from 'react-router-dom';

import { ErrorPage } from './ErrorPage';

/**
 * A URL that matches no route.
 *
 * The path is echoed back because the commonest cause is a truncated or
 * hand-edited link, and seeing where it stops is what tells the user that. It is
 * rendered as text — never as HTML, never as a link — so a crafted path cannot
 * become clickable content on our own origin.
 */
export function NotFoundPage() {
  const { pathname } = useLocation();

  return (
    <ErrorPage
      code="404"
      title="That page does not exist"
      detail={`Nothing in the workspace answers to ${pathname}. The link may be truncated, or the item may have been removed.`}
    />
  );
}
